import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { StringUtils } from '@shared/helpers/StringUtils';
import { ConvenioDto, ConvenioServiceProxy, PacienteConvenioDto, PacienteConvenioServiceProxy } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';

@Component({
  selector: 'app-edit-convenio-paciente',
  templateUrl: './edit-convenio-paciente.component.html',
})
export class EditConvenioPacienteComponent extends AppComponentBase implements OnInit {

  public pacienteId: string;
  protected pacienteConvenio: PacienteConvenioDto;
  protected convenios: ConvenioDto[] = [];
  protected data: string;
  protected saving: boolean = false;
  @Output() onSave = new EventEmitter<any>();

  constructor(
    injector: Injector,
    private readonly _pacienteConvevioService: PacienteConvenioServiceProxy,
    private readonly _convenioService: ConvenioServiceProxy,
    public bsModalRef: BsModalRef
  ) {
    super(injector)
  }

  ngOnInit(): void {
    if(this.pacienteConvenio.validade)
      this.data = this.pacienteConvenio.validade.format("DD/MM/YYYY");

    this.getConvenios();
  }

  protected save(): void {
    if (!this.IsFormValided()) return;

    abp.ui.setBusy();
    this.pacienteConvenio.validade = moment(this.data, "DDMMYYYY");
    this._pacienteConvevioService.update(this.pacienteConvenio).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.onSave.emit();
      this.bsModalRef.hide();
    })
  }

  private getConvenios(): void {
    abp.ui.setBusy();
    this._convenioService.getConveniosSemVinculoPaciente(this.pacienteId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.convenios = result;
    })
  }

  protected IsFormValided(): boolean {
    let dataValidade = moment(this.data, "DDMMYYYY");

    var validations = [
      { condition: StringUtils.isNullOrEmpty(this.pacienteConvenio.convenioId), message: "Informe o convênio." },
      { condition: StringUtils.isNullOrEmpty(this.pacienteConvenio.plano), message: "Informe o plano." },
      { condition: StringUtils.isNullOrEmpty(this.pacienteConvenio.numeroCarteira), message: "Informe o número da carteira." },
      { condition: StringUtils.isNullOrEmpty(this.data), message: "Informe a data de válidade" },
      { condition: moment(dataValidade).isBefore(moment()), message: "Data de validade inválida." },
    ];

    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }
}
